import { createApiThunk } from 'utils/thunkWrapper'
import {
  getAdminLeaderboard,
  getChallengeInsights as getChallengeInsightsApi,
  recalculateChallenge as recalculateChallengeApi,
} from 'api/challenges-v2'
import type { GetLeaderboardResponse, GetChallengeInsightsResponse, RecalculateChallengeResponse } from 'api/types'

export const getChallengeLeaderboard = createApiThunk<GetLeaderboardResponse, ChallengeLeaderboardPayload>({
  action: 'challenge/leaderboard',
  request: (payload) => getAdminLeaderboard(payload.challengeId),
})

export const getChallengeInsights = createApiThunk<GetChallengeInsightsResponse, string>({
  action: 'challenge/insights',
  request: (id) => getChallengeInsightsApi(id),
})

export const recalculateChallenge = createApiThunk<RecalculateChallengeResponse, string>({
  action: 'challenge/recalculate',
  request: (challengeId) => recalculateChallengeApi(challengeId),
  onSuccess(payload, response, thunkApi) {
    thunkApi.dispatch(getChallengeLeaderboard({ challengeId: payload, params: { limit: 100 } }))
  },
})
